import React from 'react';

/**
 * کامپوننت ErrorHandlerSetup بسیار ساده‌سازی شده
 * در نسخه جدید به navigate نیازی نیست چون از window.location استفاده می‌کنیم
 */
const ErrorHandlerSetup: React.FC = () => {
  // این کامپوننت دیگر نیازی به کد خاصی ندارد
  // فقط به عنوان سازگاری نگه داشته شده
  
  return null;
};

export default ErrorHandlerSetup; 